import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from 'src/app/core/services/config.service';
import { Claim } from '../models/Claim';
import { ClaimActivitySearchResultItem } from '../models/ClaimActivitySearchResultItem';
import { ClaimCityResultItem } from '../models/ClaimCityResultItem';
import { ClaimStageResultItem } from '../models/ClaimStageResultItem';
import { SearchClaimActivitiesCriteria } from '../models/SearchClaimActivitiesCriteria';
import { ClaimBalanceData } from '../models/ClaimBalanceData';
import { ClaimTimelineItem } from '../models/ClaimTimelineItem';
import { LocalizationManagerService } from 'src/app/shared/services/localization-manager.service';

@Injectable({
  providedIn: 'root'
})
export class ClaimDataService {

  constructor(private http: HttpClient,
    private configService: ConfigService,
    private localizationManagerService: LocalizationManagerService) {
   
  }

   public getClaimData(id:string): Observable<Claim> {
     return this.http.get<Claim>(
       this.configService.PortalWebApiUrl + 'Claim/' + id);
   }

   public getClaimDataForWorkshop(id:string): Observable<Claim> {
     return this.http.get<Claim>(
       this.configService.PortalWebApiUrl + 'Claim/forWorkshop/' + id);
   }

   public updateClaim(claim:Claim) : Observable<string> {
    return this.http.post<string>(
      this.configService.PortalWebApiUrl + 'Claim/update', claim);
  }

  public registerClaim(claim:Claim) : Observable<string> {
    return this.http.post<string>(
      this.configService.PortalWebApiUrl + 'Claim/register', claim);
  }

  public searchClaimActivities(criteria: SearchClaimActivitiesCriteria): Observable<ClaimActivitySearchResultItem[]> {
    return this.http.post<ClaimActivitySearchResultItem[]>(
      this.configService.PortalWebApiUrl + 'Claim/searchClaimActivities', criteria);
  }

  public getClaimsCities(): Observable<ClaimCityResultItem[]> {
    return this.http.get<ClaimCityResultItem[]>(
      this.configService.PortalWebApiUrl + 'Claim/claimsCities');
  }

  public getClaimsStages(): Observable<ClaimStageResultItem[]> {
    return this.http.get<ClaimStageResultItem[]>(
      this.configService.PortalWebApiUrl + 'Claim/claimsStages');
  }

  public getClaimBalance(claimIdentifier:string): Observable<ClaimBalanceData> {
    return this.http.get<ClaimBalanceData>(
      this.configService.PortalWebApiUrl + 'Claim/claimBalance/' + claimIdentifier);
  }

   public getClaimTimeline(claimIdentifier:string): Observable<ClaimTimelineItem[]> {
     const localizationCode = this.localizationManagerService.getCurrentLocalizationKey();

    return this.http.get<ClaimTimelineItem[]>(
      this.configService.PortalWebApiUrl + 'Claim/claimTimeline/' + claimIdentifier + "/" + localizationCode);
  }

  public checkIsClaimArchive(claimIdentifier:string): Observable<boolean> {
    return this.http.get<boolean>(
      this.configService.PortalWebApiUrl + 'Claim/isArchived/' + claimIdentifier);
  }

   public getClaimTags(pattern:string): Observable<string[]> {
    return this.http.get<string[]>(
      this.configService.PortalWebApiUrl + 'Claim/getAllTags/' + pattern);
  }
}
